import { Component, OnInit , ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ParkbewilligungenData, PbKategorieTyp } from '../parkbewilligungen-data';
import { PbKundenData } from '../../../providers/pbkunden-data';
import { UserData } from '../../../providers/user-data';
import { Components } from "../../../components";
/**
 * Generated class for the PbactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbkundenselection',
  templateUrl: 'pbkundenselection.html',
})
export class PbKundenSelection  implements OnInit {
  public searchQuery : string = "";
  searchTimeout;
  public bLoading : boolean = false;
  
  @ViewChild('searchInput') searchInput;
    
  constructor(public navCtrl: NavController
            , public pbData: ParkbewilligungenData
            , public pbkData: PbKundenData
            , private _viewController: ViewController
            , private userData: UserData
            , public navParams:NavParams
    ) 
  {
    let searchterm = this.navParams.get('searchterm');
    if(searchterm &&  searchterm != ""){
      this.searchQuery = searchterm;
      this.search();
    }

  }

  ngAfterViewChecked() {
    //this.searchInput.setFocus();  
    setTimeout(() => {  
      this.searchInput.setFocus();  
    }, 200);      
}

  ngOnInit(){
    this.pbkData.searchData.length = 0;
    this.pbData.selectedKunde = null;
  }

  search(){
    
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {  
      if(this.searchQuery.trim() == ""){
        this.pbkData.searchData.length = 0;
      }
      else{
        this.bLoading = true;
        this.pbkData.search(this.searchQuery).then(data => {
          this.bLoading = false;
        })
        .catch((error: Error) => this.bLoading = false);     
      }
    }, 800);  
  }
  selectKunde(pbkunde){
    this.pbData.selectedKunde = pbkunde;
    this._viewController.dismiss(pbkunde);
  }

  close(){
    this._viewController.dismiss(null);
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbkundenselection/pbkundenselection.ts